import React from 'react';
import Admin from "../../../components/pages/form/Admin/Admin";

const AdminPage = () => {
    return <Admin />
};

export default AdminPage;